import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import {
    ContentDossierNotificationsProps,
    ContentDossierNotificationsState,
} from '../types'
import { ToolbarButton } from '@/Components/Elements/StyledComponents/Buttons'

class ContentDossierNotifications extends React.Component<
    ContentDossierNotificationsProps,
    ContentDossierNotificationsState
> {
    constructor(props: ContentDossierNotificationsProps) {
        super(props)
        this.state = {
            subscribed: this.props.subscribed === true ? true : false,
        }
        this.subscribeOrUnsubscribeDossier =
            this.subscribeOrUnsubscribeDossier.bind(this)
    }

    subscribe() {
        const url = this.props.kedo
            .api()
            .getContentDossierSubscriptionEndpoint(this.props.dossier.id, true)
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .get(url)
            .then((response: any) =>
                this.setState({
                    subscribed: response.data.result === true ? true : false,
                    loading: false,
                })
            )
    }

    unsubscribe() {
        const url = this.props.kedo
            .api()
            .getContentDossierSubscriptionEndpoint(this.props.dossier.id, false)
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .get(url)
            .then((response: any) =>
                this.setState({
                    subscribed: response.data.result === false ? true : false,
                    loading: false,
                })
            )
    }

    subscribeOrUnsubscribeDossier() {
        if (this.state.subscribed === true) {
            return this.unsubscribe()
        } else {
            return this.subscribe()
        }
    }

    render() {
        return (
            <ToolbarButton
                dense={this.props.size === 'sm'}
                variant={this.state.subscribed ? 'contained' : 'outlined'}
                onClick={this.subscribeOrUnsubscribeDossier}
                title="Ontvang notificaties"
            >
                {this.state.loading ? (
                    <LoadingDefault as={'span'} />
                ) : (
                    <FontAwesomeIcon icon={faBell} />
                )}
            </ToolbarButton>
        )
    }
}

export default ContentDossierNotifications
